import React from 'react';
export function Contact() {
  return <section className="py-24 px-6 bg-white" data-id="element-8">
      <div className="max-w-4xl mx-auto text-center" data-id="element-9">
        <h2 className="text-3xl md:text-4xl mb-12 text-navy" data-id="element-10">Contact</h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 max-w-2xl mx-auto" data-id="element-11">
          <div className="space-y-4" data-id="element-12">
            <h3 className="text-sm font-bold uppercase tracking-widest text-gray-400 font-sans" data-id="element-13">
              Office
            </h3>
            <p className="text-lg text-gray-800 font-light" data-id="element-14">
              118 Portsmouth Avenue
              <br data-id="element-15" />
              Suite D204
              <br data-id="element-16" />
              Stratham, NH 03885
            </p>
          </div>

          <div className="space-y-4" data-id="element-17">
            <h3 className="text-sm font-bold uppercase tracking-widest text-gray-400 font-sans" data-id="element-18">
              Inquiries
            </h3>
            <p className="text-lg text-gray-800 font-light" data-id="element-19">
              <a href="mailto:info@mfcinv.com" className="hover:text-navy transition-colors" data-id="element-20">
                info@mfcinv.com
              </a>
            </p>
            <p className="text-base text-gray-600 font-light mt-2" data-id="element-21">
              <a href="tel:+16033217132" className="hover:text-navy transition-colors" data-id="element-22">
                
              </a>
            </p>
          </div>
        </div>

        <p className="mt-16 text-sm text-gray-400 italic" data-id="element-23">
          By appointment only.
        </p>
      </div>
    </section>;
}